import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Stats from "./components/Stats";
import Services from "./components/Services";
import Benefits from "./components/Benefits";
import FilmTypes from "./components/FilmTypes";
import Gallery from "./components/Gallery";
import Process from "./components/Process";
import Blog from "./components/Blog";
import FinalCTA from "./components/FinalCTA";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";

function Landing() {
  return (
    <div data-testid="landing-page" className="bg-[#0A0B0E] text-white min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <Stats />
        <Services />
        <Benefits />
        <FilmTypes />
        <Gallery />
        <Process />
        <Blog />
        <FinalCTA />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
